<template>
  <div>
    <!-- Loading Dialog -->
    <naj-modal
      ref="loadingModal"
      :header="false"
      :width="300"
      no-gutters
      persistent
    >
      <v-card
        color="primary"
        dark
      >
        <v-card-text>
          {{ local.common.loading }}
          <v-progress-linear
            indeterminate
            color="white"
            class="mb-0"
          ></v-progress-linear>
        </v-card-text>
      </v-card>
    </naj-modal>

    <printing-page v-if="data.totalCount">
      <papers-header :title="query.title">
        <h3 v-if="userInfo.courtName">
          {{ userInfo.courtName }}
        </h3>
        <h3 v-if="userInfo.subCircleName">
          {{ userInfo.subCircleName }}
        </h3>
      </papers-header>

      <paper v-if="headers && headers.length">
        <div v-if="queryFilters && queryFilters.length">
          <v-row>
            <v-col
              v-for="filter in queryFilters"
              :key="filter.label"
              cols="12"
              lg="4"
            >
              <h2>
                <span>{{ filter.label }}:</span>
                <span>{{ filter.value | hindiNumbers }}</span>
              </h2>
            </v-col>
          </v-row>
        </div>
        <hr class="naj-separator">
        <naj-data-table
          no-header
          :headers="headers"
          :loading="tableLoading"
          :items="castedItems"
          :disable-items-per-page="true"
          :server-items-length="total"
          :pagination="false"
        ></naj-data-table>
      </paper>

      <printing-action></printing-action>
    </printing-page>
  </div>
</template>

<script>
import PrintingPage from '@/components/printing/page.vue';
import Paper from '@/components/printing/paper.vue';
import PapersHeader from '@/components/printing/header.vue';
import PrintingAction from '@/components/printing/action.vue';
import { createNamespacedHelpers } from 'vuex';

const { mapState } = createNamespacedHelpers('GlobalModule');

export default {
  name: 'PrintDataGrid',
  components: { PrintingPage, Paper, PapersHeader, PrintingAction },
  props: ['query'],
  data () {
    return {
      tableLoading: false,
      data: {
        totalCount: 0,
      },
    };
  },
  mounted () {
    this.init();
    this.getTableData();
  },
  computed: {
    ...mapState({
      userInfo: state => state.userInfo,
    }),
    items () {
      return this.data.list;
    },
    total () {
      return this.data.totalCount;
    },
    headers () {
      const headers = JSON.parse(this.query.headers);
      return headers.filter(h => !h.slot && h.value !== 'action');
    },
    searchQuery () {
      const query = this.query.searchQuery ? JSON.parse(this.query.searchQuery) : {};
      Object.keys(query).forEach(key => query[key] == null && delete query[key]);
      return query;
    },
    filters () {
      return JSON.parse(this.query.filters);
    },
    queryFilters () {
      return Object.keys(this.searchQuery)
        .map((f1) => {
          const filter = this.filters.find(f2 => f1 === f2.name);
          let value = this.searchQuery[f1];
          if (filter.dataSource) {
            value = ((filter.dataSource || []).find(d => d.id === value) || {}).name;
          }
          if (filter) {
            return { label: filter.label, value, order: filter.order };
          } else {
            return {};
          }
        })
        .sort((a, b) => a.order - b.order);
    },
    castedItems () {
      const items = JSON.parse(JSON.stringify(this.items || []));
      return items.map((obj) => {
        for (const key in obj) {
          if (Object.prototype.hasOwnProperty.call(obj, key)) {
            if (!isNaN(+obj[key])) {
              obj[key] = this.$options.filters.hindiNumbers(+obj[key]);
            }
          }
        }
        return obj;
      });
    },
  },
  methods: {
    // ...mapActions([
    //   'getUserInfo',
    //   'getDataGridConfigurations',
    //   'getDataGridItems',
    //   'pageSizeChange',
    //   'searchChange',
    // ]),
    init () {
      this.$refs.loadingModal.show();
    },
    getTableData () {
      this.tableLoading = true;
      const { name, payload } = JSON.parse(this.query.getDataAction);
      this.$store
        .dispatch(name, payload)
        .then((res) => {
          this.data = res.data;
        })
        .finally(() => {
          this.$refs.loadingModal.close();
          this.tableLoading = false;
        });
    },
  },
};
</script>

<style lang="scss" scoped>
::v-deep {
  .v-data-table {
    thead.v-data-table-header tr th {
      font-size: 14px;
    }
    tbody tr td {
      font-size: 13px;
    }
  }
  .v-data-footer {
    display: none;
  }
}
</style>
